module.exports = __webpack_public_path__ + "static/img/智慧网银_bj@2x.edce80cd.png";